'use strict'

export class Cell {
  constructor ({
    answer = null,
    arrow = null,
    axes = [],
    background = null,
    backgroundShape = null,
    blockchr = '.',
    cellNumber = null,
    cellType = null,
    clues = [],
    idx = null,
    layout = null,
    metadata = null,
    x = null,
    y = null,
    z = null,
    words = []
  } = {}
  ) {
    this.answer = answer
    this.arrow = arrow
    this.axes = axes
    this.background = background
    this.backgroundShape = backgroundShape
    this.cellNumber = cellNumber
    this.cellType = cellType
    this.clues = clues
    this.layout = layout
    this.metadata = metadata
    this.words = words

    this.idx = idx // Must be an Integer. 1-based.

    // Should be deprecated.
    this.x = x // Must be an Integer. 0-based.
    this.y = y // Must be an Integer. 0-based.
    this.z = z || 0 // Must be an Integer. 0-based.

    // Three-dimensional support.
    if (this.coords) {
      this.x = this.coords[0] // Must be an Integer. 0-based.
      this.y = this.coords[1] // Must be an Integer. 0-based.
      this.z = this.coords[2] // Must be an Integer. 0-based.
    }

    this._blockchr = blockchr
  }

  get answer () {
    return this['_answer']
  }

  set answer (value) {
    this['_answer'] = value
  }

  get arrow () {
    return this['_arrow']
  }

  set arrow (value) {
    this['_arrow'] = value
  }

  get axes () {
    return this['_axes']
  }

  set axes (value) {
    this['_axes'] = value
  }

  get background () {
    return this['_background']
  }

  set background (value) {
    this['_background'] = value
  }

  get backgroundShape () {
    return this['_backgroundShape']
  }

  set backgroundShape (value) {
    this['_backgroundShape'] = value
  }

  get cellNumber () {
    return this['_cellNumber']
  }

  set cellNumber (value) {
    this['_cellNumber'] = value
  }

  get cellType () {
    return this['_cellType']
  }

  set cellType (value) {
    this['_cellType'] = value
  }

  get cellId () {
    return 'cell-' + [this.x, this.y, this.z].join('_')
  }

  get clues () {
    return this['_clues']
  }

  set clues (value) {
    this['_clues'] = value
  }

  get isBlock () {
    return !this.answer || this.answer === this._blockchr
  }

  get layout () {
    return this['_layout']
  }

  set layout (value) {
    this['_layout'] = value
  }

  get metadata () {
    return this['_metadata']
  }

  set metadata (value) {
    this['_metadata'] = value
  }

  get words () {
    return this['_words']
  }

  set words (value) {
    this['_words'] = value
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/cell.js
// module id = 620
// module chunks = 0